import fetch from './fetch';
import config from './config';
import http from './http';

const api = {
  fetch,
  config,
  http
};

export default api;
